import React from 'react'
import { useWorkListStoreManager } from 'context/HomeStore/Manager/WorkListsProvider/WorkListProvider.manager'
import { ALL, AllStatusesDeal } from 'constants/deals'

import { ButtonTab, ButtonTabsContainer } from 'components/Mobile/ButtonTabs'
import { makeStyles } from '@material-ui/core'
import { BASE_COLORS, GRAY_COLORS } from 'asterX-UI'

const useStyle = makeStyles(theme => ({
  chip: {
    padding: '2px 8px',
    borderRadius: 12,
    backgroundColor: GRAY_COLORS[50],
    color: GRAY_COLORS[700],
    border: `1px solid ${GRAY_COLORS[200]}`,
    fontSize: 12,
    lineHeight: '18px',
    fontWeight: 500
  }
}))

const TabsWl = () => {
  const classes = useStyle()
  const { workListStore, workListStoreFunc } = useWorkListStoreManager()
  const { selectedTab, countsTab } = workListStore
  const { changeTab } = workListStoreFunc

  return (
    <ButtonTabsContainer>
      {AllStatusesDeal.map((item, index) => {
        return (
          <ButtonTab
            key={index}
            isActive={selectedTab === item.code}
            onClick={() => changeTab(item.code)}
          >
            {item.name}

            {/* {countsTab[item.code] && (
              <span className={classes.chip}>{countsTab[item.code]}</span>
            )} */}
          </ButtonTab>
        )
      })}
    </ButtonTabsContainer>
  )
}

export default TabsWl
